import Cookies, { CookieAttributes } from 'js-cookie';

const defaultAttributes: CookieAttributes = {
  expires: 365,
  domain: process.env.PREACT_APP_COOKIE_DOMAIN,
  path: '/',
  sameSite: 'Lax',
  secure: process.env.NODE_ENV === 'production',
};

const cookies = Cookies.withAttributes(defaultAttributes);

export const getCookie = (name: string) => {
  return cookies.get(name);
};

export const setCookie = (name: string, value: string, attributes?: CookieAttributes) => {
  cookies.set(name, value, attributes);
};

export const getOrSetCookie = (name: string, defaultValue: string | (() => string), forceSet = false) => {
  const currentValue = getCookie(name);
  if (currentValue && !forceSet) {
    return currentValue;
  }
  const value = currentValue ?? (typeof defaultValue === 'function' ? defaultValue() : defaultValue);
  setCookie(name, value);
  return value;
};

export const removeCookie = (name: string, attributes?: Pick<CookieAttributes, 'path' | 'domain'>) => {
  cookies.remove(name, attributes);
};
